import React, { useEffect, useState } from 'react';
export const StudentSignUpHeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  return <section className="pt-32 pb-16 bg-navy-900 relative overflow-hidden" data-id="element-10933">
      <div className="absolute inset-0 z-0" data-id="element-10934">
        {/* Background image with overlay */}
        <div className="absolute inset-0 bg-navy-900/70 z-10" data-id="element-10935"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/jHq7syRPH1nWc94gqptCbD/Piano_teacher2.jpg')`
      }} data-id="element-10936"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-10937">
        <div className="text-center" data-id="element-10938">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-10939">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-10940">
              Start Your Musical{' '}
              <span className="text-deep-pink" data-id="element-10941">Journey Today</span>
            </h1>
            <p className="text-xl text-white mb-8 max-w-3xl mx-auto" data-id="element-10942">
              Find the perfect music teacher near you or online.
            </p>
          </div>
        </div>
      </div>
    </section>;
};